import React, { useState, useEffect, useRef } from 'react';
import './headerNew1.scss';
import Logo from '../../../assets/images/logo.png';
import { FaUser, FaBell, FaCog, FaSignOutAlt } from 'react-icons/fa';
import MobileRightSidebar from './MobileRightSidebar';
import MobileLeftSidebar from './MobileLeftSidebar';
import DesktopRightSidebar from './DesktopRightSidebar';
import {
    useGetNotificationsQuery,
    useReadNotificationClientMutation,
} from "services/clientApi";
import { useNavigate } from "react-router-dom";
import menuData from "./menuData.js"
import ProfileDropdown from "./ProfileDropdown"
import NotificationDropdown from "./NotificationDropdown"

export default function HeaderNew1({ isMobile, main, showSidebar, setShowSidebar, hasOverflowY }) {
    const navigate = useNavigate();
    const { data: notifications, isLoading: loadingNoti, isError: errorNoti, refetch } = useGetNotificationsQuery();
    const [makeNotificationSeen] = useReadNotificationClientMutation();
    const [activeMenu, setActiveMenu] = useState(null);
    const [mobileHamburgerMenu, setMobileHamburgerMenu] = useState(false);
    const [menuClicked, setMenuClicked] = useState(false);
    const [submenuHeight, setSubmenuHeight] = useState(270);
    const [showNotifications, setShowNotifications] = useState(false);
    const [showDesktopProfileMenu, setShowDesktopProfileMenu] = useState(false);
    const [needMorespace, setNeedMoreSpace] = useState(false);
    const submenuRef = useRef(null);
    const dropdownRef = useRef();
    const profiledropdownRef = useRef(null);


    const logOut = () => {
        localStorage.removeItem("isClient");
        localStorage.removeItem("auth_client");
        navigate("/login");
    };

    const makeAllNotificationSeen = () => {
        const allNotiIds = notifications?.notifications?.map(noti => noti.id) || [];

        if (allNotiIds.length > 0) {
            makeNotificationSeen({ notification_id: allNotiIds });
            refetch();
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowNotifications(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // useEffect(() => {
    //     if (submenuRef.current && activeMenu) {
    //         const height = submenuRef.current.scrollHeight;

    //         if (needMorespace) {
    //             setSubmenuHeight(height + 100);
    //             setNeedMoreSpace(false);
    //         } else {
    //             setSubmenuHeight(height + 100);
    //         }
    //     } else {
    //         setSubmenuHeight(0);
    //     }
    // }, [activeMenu]);

    return (
        <>
            <header className="header-new" onMouseLeave={() => setActiveMenu(null)}>
                <div className="header-content">
                    {isMobile ? (
                        <>
                            <div id="nav-icon2" style={{ margin: "15px 10px 10px 10px" }} className={`${menuClicked ? "open" : ""}`} onClick={() => { setMenuClicked(!menuClicked); setMobileHamburgerMenu(!mobileHamburgerMenu); }}>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <button type="button" className="header-brand header-brand--mobile" onClick={() => navigate("/")} aria-label="Go to dashboard">
                                <span className="brand-logo-frame"><img src={Logo} alt="Banque Artesia Nederland N.V." /></span>
                            </button>
                            <MobileLeftSidebar
                                mobileHamburgerMenu={mobileHamburgerMenu}
                                setMobileHamburgerMenu={setMobileHamburgerMenu}
                                menuData={menuData}
                                isMobile={isMobile}
                                menuClicked={menuClicked}
                                setMenuClicked={setMenuClicked} />
                        </>
                    ) : (
                        <div className="left-section ml20 mt-3">
                            <button type="button" className="header-brand" onClick={() => navigate("/")} aria-label="Go to dashboard">
                                <span className="brand-logo-frame"><img src={Logo} alt="Banque Artesia Nederland N.V." /></span>
                            </button>
                            <nav className="d-none d-md-flex text-uppercase custom-margin">
                                {Object.keys(menuData).map((item, index) => (
                                    <div
                                        key={item}
                                        className={`nav-item-wrapper ${activeMenu === item ? 'active' : ''}`}
                                        onMouseEnter={() => { setActiveMenu(item); index === 5 && setNeedMoreSpace(true); }}
                                    >
                                        <a>{item}</a>
                                    </div>
                                ))}
                            </nav>
                        </div>
                    )}


                    {isMobile ? (
                        <div className="icon-group py-4" onClick={() => setShowSidebar(true)}>
                            <FaUser className="icon-hover mx-3" />
                        </div>
                    ) : (
                        <div className="icon-group py-4">
                            <div className='mx-3 position-relative' ref={profiledropdownRef}>
                                <FaUser className="icon-hover" onClick={() => setShowDesktopProfileMenu(!showDesktopProfileMenu)} />
                                <ProfileDropdown
                                    showDesktopProfileMenu={showDesktopProfileMenu}
                                    main={main}
                                    setShowDesktopProfileMenu={setShowDesktopProfileMenu}
                                    profiledropdownRef={profiledropdownRef}
                                />
                            </div>

                            <div className="mx-3 position-relative" ref={dropdownRef}>
                                <FaBell
                                    onClick={() => {
                                        const shouldShow = !showNotifications;
                                        setShowNotifications(shouldShow);
                                        if (shouldShow) refetch();
                                    }}
                                    style={{ cursor: 'pointer' }}
                                    className='icon-hover'
                                />
                                {notifications?.count > 0 && (
                                    <span className="notification-bell-count">{notifications.count}</span>
                                )}
                                <NotificationDropdown
                                    showNotifications={showNotifications}
                                    notifications={notifications}
                                    makeAllNotificationSeen={makeAllNotificationSeen}
                                    makeNotificationSeen={makeNotificationSeen}
                                />

                            </div>

                            <FaCog className="icon-hover mx-3" onClick={() => navigate('/alert-panel')} />

                            <span className="mx-3 text-muted">|</span>
                            <div
                                onClick={logOut}
                            >
                                <FaSignOutAlt className="icon-hover mx-3" onClick={logOut} />
                            </div>
                        </div >
                    )}
                </div>

                <div
                    className={`submenu-container ${activeMenu ? 'submenu-active' : ''}`}
                    style={{
                        height: submenuHeight,
                        transition: 'height 0.3s ease',
                        overflow: 'hidden'
                    }}
                >
                    {activeMenu && (
                        <div
                            className="submenu d-flex flex-column h-100"
                            ref={submenuRef}
                            onMouseEnter={() => setActiveMenu(activeMenu)}
                            onMouseLeave={() => setActiveMenu(null)}
                        >
                            <div className="d-flex flex-wrap flex-grow-1">
                                {menuData[activeMenu].map((group, idx) => (
                                    <div key={idx} className="submenu-column px-4">
                                        <div className="submenu-label mb-4">{group.label.toUpperCase()}</div>
                                        {group.submenus.map((submenu, i) => (
                                            <div className="submenu-item py-1" key={i}>
                                                <a onClick={() => navigate(submenu.path)}>{submenu.label}</a>
                                            </div>
                                        ))}
                                    </div>
                                ))}
                            </div>

                            <div className="w-100" style={{ borderBottom: "2px solid #1E266D" }}></div>
                        </div>
                    )}
                </div>

            </header >

            {
                isMobile ? (
                    <MobileRightSidebar showSidebar={showSidebar} setShowSidebar={setShowSidebar} isMobile={isMobile} user={main?.user} />
                ) : (
                    <DesktopRightSidebar showSidebar={showSidebar} setShowSidebar={setShowSidebar} isMobile={isMobile} user={main?.user} hasOverflowY={hasOverflowY} />
                )
            }
        </>
    );
}
